import { AnimatePresence, motion } from "framer-motion";
import { navItems } from "../data/profile";
import s from "./Nav.module.css";

interface Props {
  open: boolean;
  onNavigate: (hash: string) => (e: React.MouseEvent) => void;
}

/** Motion-only leaf: the nav itself is driven by GSAP ScrollTrigger. */
export default function MobileMenu({ open, onNavigate }: Props) {
  return (
    <AnimatePresence>
      {open && (
        <motion.nav
          id="mobile-menu"
          aria-label="Primary, mobile"
          className={s.sheet}
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8, transition: { duration: 0.18 } }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
        >
          {navItems.map((item, i) => (
            <motion.a
              key={item.hash}
              href={item.hash}
              className={s.sheetLink}
              onClick={onNavigate(item.hash)}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.04 * i + 0.08, duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            >
              {item.label}
            </motion.a>
          ))}
        </motion.nav>
      )}
    </AnimatePresence>
  );
}
